<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">贝利婴幼儿发展量表第四版中文·筛查版统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <div class="main-body column">
      <div class="header">
        <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span class="name">认知、语言、动作测试</span>
        </div>
      </div>
      <div class="body">
        <a-form-model ref="form" :model="formModel" autoComplete="off" :label-col="labelCol" :wrapper-col="wrapperCol"
          labelAlign="left">

          <!-- 标签页切换 -->
          <a-tabs v-model="activeTab" @change="handleTabChange">
            <a-tab-pane key="cg" tab="认知(CG)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('cg') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in cgItems" :key="'cg-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('cg', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ cgTitles[index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('cg', index)"
                      @change="handleScoreChange('cg', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="rc" tab="语言-接受性沟通(RC)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('rc') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in rcItems" :key="'rc-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('rc', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ rcTitles[index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('rc', index)"
                      @change="handleScoreChange('rc', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="ec" tab="语言-表达性沟通(EC)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('ec') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in ecItems" :key="'ec-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('ec', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ ecTitles[index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('ec', index)"
                      @change="handleScoreChange('ec', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="fm" tab="动作-精细动作(FM)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('fm') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in fmItems" :key="'fm-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('fm', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ fmTitles[index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('fm', index)"
                      @change="handleScoreChange('fm', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>

            <a-tab-pane key="gm" tab="动作-粗大动作(GM)">
              <div class="tab-content">
                <div class="score-summary">
                  <span class="score-label">总分：</span>
                  <span class="score-value">{{ getTotalScore('gm') }}</span>
                </div>
                <div class="items-container">
                  <div v-for="(item, index) in gmItems" :key="'gm-' + index" class="item-row"
                    :class="{ 'disabled': isItemDisabled('gm', index) }">
                    <span class="item-label">题目 {{ item.itemNo }}：{{ gmTitles[index] || '' }}</span>
                    <a-radio-group v-model="item.score" :disabled="isItemDisabled('gm', index)"
                      @change="handleScoreChange('gm', index)">
                      <a-radio :value="0">0</a-radio>
                      <a-radio :value="1">1</a-radio>
                      <a-radio :value="2">2</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>

          <!-- 原始表单字段，现在隐藏起来，用于提交 -->
          <div style="display: none;">
            <a-form-model-item label="认知(CG)" prop="simple.score_cg">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_cg" class="cu-input1 input-number-100" :min="0"
                  :max="60" />
                <span class="num-de"><0-60></span>
              </div>
            </a-form-model-item>
            <a-form-model-item label="语言-接受性沟通(RC)" prop="simple.score_rc">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_rc" class="cu-input1 input-number-100" :min="0"
                  :max="44" />
                <span class="num-de"><0-44></span>
              </div>
            </a-form-model-item>
            <a-form-model-item label="语言-表达性沟通(EC)" prop="simple.score_ec">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_ec" class="cu-input1 input-number-100" :min="0"
                  :max="46" />
                <span class="num-de"><0-46></span>
              </div>
            </a-form-model-item>
            <a-form-model-item label="动作-精细动作(FM)" prop="simple.score_fm">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_fm" class="cu-input1 input-number-100" :min="0"
                  :max="54" />
                <span class="num-de"><0-54></span>
              </div>
            </a-form-model-item>
            <a-form-model-item label="动作-粗大动作(GM)" prop="simple.score_gm">
              <div class="flex">
                <a-input-number v-model="formModel.simple.score_gm" class="cu-input1 input-number-100" :min="0"
                  :max="54" />
                <span class="num-de"><0-54></span>
              </div>
            </a-form-model-item>
          </div>

          <div style="display: flex;align-items: center;justify-content: center; margin-top: 20px;">
            <div class="btn" @click="actionData">{{ id != '' ? '编辑并生成报告' : '保存并生成报告' }}</div>
          </div>
        </a-form-model>
      </div>
    </div>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import { Save, Detail, Update } from '../../commonApi';
import { base, simple, simpleRule } from "../simple-field";
import { message } from "ant-design-vue";
import * as Api from "../base-info/api";
import moment from "moment";

export default {
  data() {
    return {
      activeTab: 'cg', // 默认选中认知标签页
      // 各个测试项目的题目数据
      cgItems: this.initItems(30),  // 认知，30题
      rcItems: this.initItems(22),  // 接受性沟通，22题
      ecItems: this.initItems(23),  // 表达性沟通，23题
      fmItems: this.initItems(27),  // 精细动作，27题
      gmItems: this.initItems(27),  // 粗大动作，27题

      // 题目标题数据
      cgTitles: [
        '被抱起时平静下来', '注视物体', '对照护者的反应', '注意转移', '表现出视觉偏好',
        '对气球（图片）习惯', '探索物体', '拍打桌子', '预期注视', '看图',
        '寻找消失的物品', '搅动勺子', '杯中积木', '寻找隐藏的物品', '吊环',
        '取出食物粒', '粉色板', '专心听故事', '蓝色板系列：1块', '插板',
        '用铅笔获取物体', '表征性游戏', '蓝色板系列：9块', '空间记忆：3张卡', '假想性游戏',
        '回忆名字', '拼图：猫', '区分图形', '空间记忆：6张卡', '背数'
      ],
      rcTitles: [
        '讲话时平静', '对人声有反应', '对照护者的反应', '注意转移', '探索物体',
        '将物体拿到嘴边', '敲打物体', '对名字有应答', '听辨词语', '对日常社交要求有应答',
        '识别物品', '识别图片系列：3个正确', '娃娃部位系列：2个正确', '识别图片系列：6个正确', '识别衣物',
        '娃娃部位系列：5个正确', '理解局部/整体的关系', '理解大小', '理解复数形式', '理解"更多"',
        '理解重量', '理解"较少"'
      ],
      ecTitles: [
        '未分化发音', '社会性微笑', '发声表达情绪', '社会性发声或笑', '发出元音',
        '吸引关注/互动', '发出辅音', '使用肢体语言', '含糊不清的话', '引导他人对物体的关注',
        '发起游戏', '合理使用词语', '理解度：50%', '物品命名', '回答是否题',
        '理解度：75%', '说出3个词的句子', '动作命名系列：3个正确', '提出问题', '使用现在进行时',
        '使用不同的词语组合', '动作命名系列：5个正确', '说出物体用途'
      ],
      fmTitles: [
        '目光追随移动的人', '目光追随吊环：水平方向', '尝试伸手入口', '手握吊环', '头随吊环转动',
        '手掌握持反射', '伸手拿/碰积木', '积木抓握系列：整手抓握', '看着食物粒', '抓食物粒系列：整手抓握',
        '将积木或圆环换手', '自主进食', '积木抓握系列：拇指-指尖抓握', '抓食物粒系列：灵巧钳式抓握', '翻书',
        '手指戳插板', '主动涂画', '抓握铅笔系列：过渡阶段', '将硬币投入存钱罐', '抓握铅笔系列：静态三点握笔',
        '搭积木系列：6块积木', '拼插积木', '搭积木系列：8块积木', '穿积木', '折纸',
        '模仿画加号', '抓握铅笔系列：动态握笔'
      ],
      gmTitles: [
        '伸展双臂和双腿', '控制头部：保持头部直立3秒', '俯卧时控制头部：45°', '向下降落伞反射', '翻身：从俯卧到仰卧',
        'ATNR非对称性紧张性颈反射', '翻身：从仰卧到侧卧', '足抓握反射', '站立：背部竖直', '拉起至坐位',
        '爬行：腹部', '从坐位转为手膝位', '支撑体重', '爬行：爬行动作', '有支撑行走',
        '有支撑侧身走', '独站', '行走：没有帮助', '向前扔球', '独立蹲下',
        '向后倒着走', '协调地跑', '跳：双脚跳', '无需支撑，单脚平衡站立系列：2秒', '踮脚走路',
        '单脚跳1.5米', '无需支撑，单脚平衡站立：6秒'
      ],

      // 原有数据
      scoreCdTip: '<0-119>',
      scoreCdMax: 119,
      scoreBDBool: false,
      scoreCOBool: false,
      scoreDSBool: false,
      labelCol: { span: 8, style: { color: '#7E8589', fontWeight: '500' } },
      wrapperCol: { span: 14 },
      formModel: {
        base: Object.assign({}, base),
        simple: Object.assign({}, simple),
      },
      isUnit: 1, // 是否关联
      bindListVisible: false,
      id: '',
      source: ''
    }
  },
  mounted() {
    // 编辑
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
    } else {
      this.formModel.base = JSON.parse(window.localStorage.getItem('base_info'));
    }
    if (this.$route.query && this.$route.query.source) {
      this.source = this.$route.query.source;
    }
    this.scoreBDBool = false
    this.scoreCOBool = false
    this.scoreDSBool = false
    if (this.formModel.simple.simple_sub_test_num === 4) {
      this.formModel.simple.score_bd = null;
      this.formModel.simple.score_co = null;
      this.scoreBDBool = true
      this.scoreCOBool = true
    } else if (this.formModel.simple.simple_sub_test_num === 5) {
      this.formModel.simple.score_ds = null;
      this.scoreDSBool = true;
    }
  },
  methods: {
    // 初始化题目数据
    initItems(count) {
      const items = [];
      for (let i = 1; i <= count; i++) {
        items.push({
          itemNo: i.toString(),
          score: null
        });
      }
      return items;
    },

    // 处理标签页切换
    handleTabChange(activeKey) {
      this.activeTab = activeKey;
    },

    // 处理分数变更
    handleScoreChange(type, index) {
      const items = this[`${type}Items`];

      // 如果选择了某一题，则之前的题目自动满分
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          if (items[i].score === null) {
            items[i].score = 2; // 自动设为满分
          }
        }
      }

      // 检查是否触发终止规则（连续5题选0）
      this.checkTerminationRule(type);

      // 更新总分到原表单
      this.updateTotalScore();
    },

    // 检查终止规则
    checkTerminationRule(type) {
      const items = this[`${type}Items`];
      let consecutiveZeros = 0;
      for (let i = 0; i < items.length; i++) {
        if (items[i].score === 0) {
          consecutiveZeros++;
          if (consecutiveZeros >= 4) { // 从5改为4
            // 触发终止规则，后面的题目无法作答
            // 清空后续题目的选择值
            for (let j = i + 1; j < items.length; j++) {
              items[j].score = null;
            }
            break;
          }
        } else {
          consecutiveZeros = 0;
        }
      }
    },

    // 判断题目是否禁用
    isItemDisabled(type, index) {
      const items = this[`${type}Items`];

      // 检查前面是否有连续4个0分
      let consecutiveZeros = 0;
      for (let i = 0; i < index; i++) {
        if (items[i].score === 0) {
          consecutiveZeros++;
          if (consecutiveZeros >= 4) { // 从5改为4
            return true; // 禁用当前题目
          }
        } else {
          consecutiveZeros = 0;
        }
      }

      return false;
    },

    // 获取总分
    getTotalScore(type) {
      const items = this[`${type}Items`];
      let total = 0;

      for (const item of items) {
        if (item.score !== null) {
          total += item.score;
        }
      }

      return total;
    },

    // 更新总分到原表单
    updateTotalScore() {
      const cgScore = this.getTotalScore('cg');
      const rcScore = this.getTotalScore('rc');
      const ecScore = this.getTotalScore('ec');
      const fmScore = this.getTotalScore('fm');
      const gmScore = this.getTotalScore('gm');
      
      // 当分数为0时，提交null
      this.formModel.simple.score_cg = cgScore === 0 ? null : cgScore;
      this.formModel.simple.score_rc = rcScore === 0 ? null : rcScore;
      this.formModel.simple.score_ec = ecScore === 0 ? null : ecScore;
      this.formModel.simple.score_fm = fmScore === 0 ? null : fmScore;
      this.formModel.simple.score_gm = gmScore === 0 ? null : gmScore;
    },
    handleRadio() {
      this.scoreBDBool = false
      this.scoreCOBool = false
      this.scoreDSBool = false
      if (this.formModel.simple.simple_sub_test_num === 4) {
        this.formModel.simple.score_bd = null;
        this.formModel.simple.score_co = null;
        this.scoreBDBool = true
        this.scoreCOBool = true
      } else if (this.formModel.simple.simple_sub_test_num === 5) {
        this.formModel.simple.score_ds = null;
        this.scoreDSBool = true;
      }
    },

    async getDetail() {
      const res = await Detail({ id: this.id });
      if (res && res.code == 0) {
        this.formModel.simple = Object.assign({}, res.bayleyScreeningAssessment);
        this.formModel.base = {
          id: res.bayleyScreeningAssessment.id,
          name: res.bayleyScreeningAssessment.name,
          scoring_num: res.bayleyScreeningAssessment.scoring_num,
          gender: res.bayleyScreeningAssessment.gender,
          test_date: res.bayleyScreeningAssessment.test_date,
          born_date: res.bayleyScreeningAssessment.born_date,
          real_age: res.bayleyScreeningAssessment.real_age,
          is_premature_infant: res.bayleyScreeningAssessment.is_premature_infant,
          expected_date: res.bayleyScreeningAssessment.expected_date,
          adjustment_age: res.bayleyScreeningAssessment.adjustment_age,
          examiner_name: res.bayleyScreeningAssessment.examiner_name,
          caregivers_name: res.bayleyScreeningAssessment.caregivers_name,
          relationship_of_child: res.bayleyScreeningAssessment.relationship_of_child,
          relationship_remark: res.bayleyScreeningAssessment.relationship_remark,
          referral_remark: res.bayleyScreeningAssessment.referral_remark,
        }

        // 如果是编辑模式，根据已有分数初始化题目
        this.initItemsFromScores();
      }
    },

    // 从已有分数初始化题目
    initItemsFromScores() {
      try {
        // 如果有 answer_data 字段，则从中解析题目数据
        if (this.formModel.simple.answer_data) {
          const answerData = JSON.parse(this.formModel.simple.answer_data);

          // 更新各个测试项目的题目数据
          if (answerData.cg && Array.isArray(answerData.cg)) {
            this.cgItems = answerData.cg;
          }

          if (answerData.rc && Array.isArray(answerData.rc)) {
            this.rcItems = answerData.rc;
          }

          if (answerData.ec && Array.isArray(answerData.ec)) {
            this.ecItems = answerData.ec;
          }

          if (answerData.fm && Array.isArray(answerData.fm)) {
            this.fmItems = answerData.fm;
          }

          if (answerData.gm && Array.isArray(answerData.gm)) {
            this.gmItems = answerData.gm;
          }
        } else {
          // 如果没有 answer_data，但有总分，可以尝试根据总分推算
          // 这里可以根据实际业务逻辑添加推算代码
          console.log('没有详细题目数据，只有总分');
        }
      } catch (error) {
        console.error('解析 answer_data 出错:', error);
        // 解析出错时，保持默认初始化的题目数据
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatToYMD(dateStr) {
      // 分割日期和时间
      const datePart = dateStr.split('T')[0];
      return datePart;
    },

    async actionData() {
      // 提交前更新总分
      this.updateTotalScore();

      // 检查是否至少填写了一个分测验
      const hasCgData = this.cgItems.some(item => item.score !== null);
      const hasRcData = this.rcItems.some(item => item.score !== null);
      const hasEcData = this.ecItems.some(item => item.score !== null);
      const hasFmData = this.fmItems.some(item => item.score !== null);
      const hasGmData = this.gmItems.some(item => item.score !== null);

      if (!hasCgData && !hasRcData && !hasEcData && !hasFmData && !hasGmData) {
        message.error('请至少完成一个分测验');
        return;
      }

      // 新增：验证所有未禁用的题目都必须填写
      const validateRequiredItems = (items, typeName) => {
        for (let i = 0; i < items.length; i++) {
          const isDisabled = this.isItemDisabled(typeName, i);
          if (!isDisabled && items[i].score === null) {
            return {
              valid: false,
              message: `${this.getTypeDisplayName(typeName)}分测验未满足终止条件`
            };
          }
        }
        return { valid: true };
      };

      // 验证各个测试项目
      const testTypes = [
        { items: this.cgItems, type: 'cg', hasData: hasCgData },
        { items: this.rcItems, type: 'rc', hasData: hasRcData },
        { items: this.ecItems, type: 'ec', hasData: hasEcData },
        { items: this.fmItems, type: 'fm', hasData: hasFmData },
        { items: this.gmItems, type: 'gm', hasData: hasGmData }
      ];

      for (const testType of testTypes) {
        // 只验证有数据的测试项目
        if (testType.hasData) {
          const validation = validateRequiredItems(testType.items, testType.type);
          if (!validation.valid) {
            message.error(validation.message);
            return;
          }
        }
      }

      // 准备提交的答题数据，过滤掉未作答的题目（保持为null）
      const answerData = {
        cg: this.cgItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score // 如果未选择，这里就是null
        })),
        rc: this.rcItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score
        })),
        ec: this.ecItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score
        })),
        fm: this.fmItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score
        })),
        gm: this.gmItems.map(item => ({
          itemNo: item.itemNo,
          score: item.score
        }))
      };

      // 将答题数据转换为JSON字符串
      this.formModel.simple.answer_data = JSON.stringify(answerData);

      // 继续原有的提交逻辑
      console.log(this.formModel.simple);
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let res = null;
          if (this.formModel.base.born_date) {
            this.formModel.base.born_date = this.formatToYMD(this.formModel.base.born_date);
          }
          if (this.formModel.base.test_date) {
            this.formModel.base.test_date = this.formatToYMD(this.formModel.base.test_date);
          }
          if (this.formModel.base.expected_date) {
            this.formModel.base.expected_date = this.formatToYMD(this.formModel.base.expected_date);
          }
          if (this.id) {
            res = await Update({ base: this.formModel.base, assessment: this.formModel.simple });
          } else {
            res = await Save({ base: this.formModel.base, assessment: this.formModel.simple });
          }
          if (res && res.code == 0) {
            window.localStorage.removeItem('base_info');
            message.success({ content: res.message });
            setTimeout(() => {
              if (this.id == '') {
                this.$router.push({ path: "/" });
              } else if (this.id != '' && this.source == 'index') {
                this.$router.push({ path: "/" });
              } else if (this.id != '' && this.source == 'history') {
                this.$router.push({ path: "/maintain-history-report" });
              }
            }, 1500);
          }
        } else {
          message.error({ content: '表单验证未通过' });
        }
      });
    },

    // 新增辅助方法：获取测试类型的显示名称
    getTypeDisplayName(type) {
      const typeNames = {
        'cg': '认知(CG)',
        'rc': '语言-接受性沟通(RC)',
        'ec': '语言-表达性沟通(EC)',
        'fm': '动作-精细动作(FM)',
        'gm': '动作-粗大动作(GM)'
      };
      return typeNames[type] || type;
    }
  }
};
</script>
<style>
/* 标签页内容样式 */
.tab-content {
  padding: 20px 0;
}

.score-summary {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #832C75;
}

.score-label {
  margin-right: 10px;
}

.items-container {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 10px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.item-row:last-child {
  border-bottom: none;
}

.item-row.disabled {
  opacity: 0.5;
  background-color: #f5f5f5;
}

.item-label {
  font-weight: 500;
  color: #333;
  flex: 1; /* 让标题占据更多空间 */
  margin-right: 10px; /* 与选项组之间的间距 */
}
</style>
<style scoped>
.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}

.flex {
  display: flex;
}

.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 70px;
  justify-content: center;
}

.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #832C75;
  margin-bottom: 20px;
}

.cu-select {
  line-height: 42px;
  height: 42px;
}

.btn {
  background: #832C75;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 80px;
}

.btn.sh {
  border: 1px solid #832B75;
  border-radius: 5px;
  font-weight: 400;
  color: #832B75;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}

.ant-form-item {
  margin-bottom: 12px !important;
}
</style>
